import { Paragraph } from '@tmov/design-system';
import PropTypes from 'prop-types';
import React from 'react';

import {
  Container,
  Divider,
  Section,
  SectionInputs,
  SectionLabel,
} from './styles';

function FormSection({ name, description, children, isLast }) {
  return (
    <Container>
      <Divider />
      <Section>
        <SectionLabel>
          <Paragraph variant="p1" fontWeight="semibold">
            {name}
          </Paragraph>
          <p>{description}</p>
        </SectionLabel>
        <SectionInputs>{children}</SectionInputs>
      </Section>
      {isLast && <Divider />}
    </Container>
  );
}

FormSection.propTypes = {
  name: PropTypes.string.isRequired,
  description: PropTypes.string,
  children: PropTypes.node.isRequired,
  isLast: PropTypes.bool,
};

FormSection.defaultProps = {
  description: '',
  isLast: false,
};

export default FormSection;
